import { DynamoDBClient } from "@aws-sdk/client-dynamodb";
import awsConfig from "../../Components/aws-config";

const dynamoDBClient = new DynamoDBClient({
  region: awsConfig.region,
  credentials: {
    accessKeyId: awsConfig.accessKeyId,
    secretAccessKey: awsConfig.secretAccessKey,
  },
});


export default dynamoDBClient;
